//
// getBoundingClientRect returns visual px; CSS top/left values set on elements
// under the dashboard shell zoom are interpreted in layout px. Use this rect
// whenever a measured position feeds a style, so both sides share the same unit.
//

import getRenderedScale from './getRenderedScale';

const getLayoutBoundingRect = (element) => {
  const rect = element.getBoundingClientRect();
  const scale = getRenderedScale(element);
  if (scale === 1) return rect;
  return {
    left: rect.left / scale,
    top: rect.top / scale,
    right: rect.right / scale,
    bottom: rect.bottom / scale,
    width: rect.width / scale,
    height: rect.height / scale,
  };
};

export default getLayoutBoundingRect;
